__turbopack_context__.v({
  "metricItem": "Metrics-module-scss-module__P0-KFG__metricItem",
  "metrics": "Metrics-module-scss-module__P0-KFG__metrics",
  "separator": "Metrics-module-scss-module__P0-KFG__separator",
});
